import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	userInterface: {
		id: 'spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface',
		defaultMessage: 'User Interface',
		description: 'Navigation group heading for user interface settings items',
	},
	userDefaults: {
		id: 'spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults',
		defaultMessage: 'Default user preferences',
		description: 'Navigation item which links to a default user preferences settings page',
	},
	systemDashboard: {
		id: 'spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard',
		defaultMessage: 'Default dashboard',
		description: 'Navigation item which links to a default dashboard settings page',
	},
	lookAndFeel: {
		id: 'spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel',
		defaultMessage: 'Look and feel',
		description: 'Navigation item which links to a look and feel settings page',
	},
	pasAdmin: {
		id: 'spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin',
		defaultMessage: 'Public Announcement Service',
		description: 'Navigation item which links to a public announcement service settings page',
	},
	announcementBanner: {
		id: 'spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner',
		defaultMessage: 'Announcement banner',
		description: 'Navigation item which links to a public announcement service settings page',
	},
});
